import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class GlobalsService {
    languageJson: any;
    mapsApiKey = 'AIzaSyDXk_Np8JpVCzWsrThRnHev84q_38XSETw';

    constructor() {}
}
